import {
  getTrackingByGa4Id
} from "./chunk-Z3IWEC4R.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";

// src/services/getTrackingByGa4Id/getTrackingByGa4Id.ts
function getTrackingByGa4Id2(ga4Id, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getTrackingByGa4Id");
  return getTrackingByGa4Id(ga4Id, _apiConfig);
}

export {
  getTrackingByGa4Id2 as getTrackingByGa4Id
};
